// src/js/storage.js
import { Capacitor } from '@capacitor/core';
import { nativeStorageService } from './storage.native.js';
import { webStorageService } from './storage.web.js';

let storageService;

if (Capacitor.isNativePlatform()) {
    console.log("Platform: Native. Using SQLite storage.");
    storageService = nativeStorageService;
} else {
    console.log("Platform: Web. Using Preferences storage for testing.");
    storageService = webStorageService;
}

// Rename initializeDatabase to initializeStorage for semantic clarity
export const initializeStorage = () => storageService.initializeDatabase();

// Export the chosen service for the rest of the app to use
export { storageService };
